export const FETCH_FAVORITES_FOR_DOCTOR_REQUEST = '@@favorites/FETCH_FAVORITES_FOR_DOCTOR_REQUEST';
export const FETCH_FAVORITES_FOR_DOCTOR_SUCCESS = '@@favorites/FETCH_FAVORITES_FOR_DOCTOR_SUCCESS';
export const FETCH_FAVORITES_FOR_DOCTOR_FAILURE = '@@favorites/FETCH_FAVORITES_FOR_DOCTOR_FAILURE';

export const fetchAccountFavorites = (refetch = false) => ({
    type: FETCH_FAVORITES_FOR_DOCTOR_REQUEST,
    refetch,
});
